import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { NavigatorScreenParams } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import { View } from "react-native";

import Checkout from "@/screens/Checkout";
import GlobalSearch from "@/screens/Search/GlobalSearch";

import { colors } from "../theme/colors";
import { AddressStack } from "./stacks/AddressStack";
import CartStack, { CartStackParamList } from "./stacks/CartStack";
import HomeStack, { HomeStackParamList } from "./stacks/HomeStack";
import { OrderStack, OrderStackParamList } from "./stacks/OrderStack";
import { SettingsStack, SettingsStackParamList } from "./stacks/SettingsStack";

export type MobileStackParamList = {
  homeStack: NavigatorScreenParams<HomeStackParamList>;
  cartStack: NavigatorScreenParams<CartStackParamList>;
  orderStack: NavigatorScreenParams<OrderStackParamList>;
  settingsStack: NavigatorScreenParams<SettingsStackParamList>;
  search: {
    query?: string;
  };
};

const Tab = createBottomTabNavigator<MobileStackParamList>();

const TabStack = () => {
  return (
    <Tab.Navigator
      initialRouteName="homeStack"
      screenOptions={{
        headerShown: false,
        tabBarActiveTintColor: colors.primary[600],
        tabBarStyle: {
          position: "absolute",
          backgroundColor: colors.white[100],
          padding: 4,
        },
        tabBarLabelStyle: {
          fontSize: 14,
        },
      }}>
      <Tab.Screen
        name="homeStack"
        component={HomeStack}
        options={{
          title: "Home",
          tabBarLabel: "Home",
          tabBarIcon: ({ color, size }) => <Icon name="home" color={color} size={size} />,
          tabBarItemStyle: {
            flexDirection: "column",
          },
        }}
      />
      <Tab.Screen
        name="search"
        component={GlobalSearch}
        options={{
          title: "Busca",
          tabBarLabel: "Buscar",
          tabBarIcon: ({ color, size }) => <Icon name="magnify" color={color} size={size} />,
          tabBarItemStyle: {
            flexDirection: "column",
          },
        }}
      />
      <Tab.Screen
        name="cartStack"
        component={CartStack}
        options={{
          title: "Carrinho",
          tabBarLabel: "Carrinho",
          tabBarIcon: ({ focused }) => (
            <View
              style={{
                marginTop: -24,
                backgroundColor: colors.primary[600],
                padding: 10,
                borderRadius: 100,
                shadowColor: "#000",
                shadowOffset: {
                  width: 0,
                  height: 2,
                },
                shadowOpacity: 0.25,
                shadowRadius: 3.84,
                elevation: 5,
              }}>
              <Icon
                name="cart-outline"
                color={focused ? colors.secondary[400] : colors.white[100]}
                size={28}
              />
            </View>
          ),
          tabBarItemStyle: {
            flexDirection: "column",
          },
        }}
      />
      <Tab.Screen
        name="orderStack"
        component={OrderStack}
        options={{
          title: "Pedidos",
          tabBarLabel: "Pedidos",
          tabBarIcon: ({ color, size }) => (
            <Icon name="shopping-outline" color={color} size={size} />
          ),
          tabBarItemStyle: {
            flexDirection: "column",
          },
        }}
      />
      <Tab.Screen
        name="settingsStack"
        component={SettingsStack}
        options={{
          title: "Ajustes",
          tabBarLabel: "Ajustes",
          tabBarIcon: ({ color, size }) => (
            <Icon name="account-circle-outline" color={color} size={size} />
          ),
          tabBarItemStyle: {
            flexDirection: "column",
          },
        }}
      />
    </Tab.Navigator>
  );
};

const Mobile = createStackNavigator();

const MobileNavigator = () => {
  return (
    <Mobile.Navigator
      initialRouteName="tabs"
      screenOptions={{ headerShown: false, headerMode: "screen" }}>
      <Mobile.Screen name="tabs" component={TabStack} />
      <Mobile.Screen name="addressStack" component={AddressStack} />
      <Mobile.Screen name="checkout" component={Checkout} options={{ title: "Checkout" }} />
    </Mobile.Navigator>
  );
};

export default MobileNavigator;
